"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeUserId = exports.xorStrings = exports.chunkString = exports.base64EncodeString = exports.computeTotpFromSharedSecret = void 0;
var totp_1 = require("./totp");
Object.defineProperty(exports, "computeTotpFromSharedSecret", { enumerable: true, get: function () { return totp_1.computeTotpFromSharedSecret; } });
/**
 * Create Base64 encoded string.
 */
function base64EncodeString(str) {
    if (typeof btoa !== 'undefined') {
        return btoa(str);
    }
    else {
        return Buffer.from(str).toString('base64');
    }
}
exports.base64EncodeString = base64EncodeString;
/**
 * Splits `str` into chunks having length of at most `size`.
 *
 * @see {@link https://stackoverflow.com/a/29202760}
 */
function chunkString(str, size) {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);
    for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
        chunks[i] = str.substr(o, size);
    }
    return chunks;
}
exports.chunkString = chunkString;
/**
 * XORs the input strings producing an output hex-encoded string.
 */
function xorStrings(...strings) {
    const longestLength = strings.reduce((memo, str) => {
        if (memo === -1 || str.length > memo) {
            memo = str.length;
        }
        return memo;
    }, -1);
    let result = '';
    for (let i = 0; i < longestLength; ++i) {
        //get the character at position i of each input string
        const charsAtI = strings.map(chunk => chunk.charCodeAt(i));
        //compute the serial XOR of each input character. If any
        //character is "missing", it is ignored.
        const byte = charsAtI.reduce((memo, value) => {
            if (-1 === memo) {
                return value;
            }
            if (Number.isNaN(value)) {
                return memo;
            }
            return memo ^ value;
        }, -1);
        //append the byte to the result in hex-encoded format
        result += String.fromCharCode(byte);
    }
    return result;
}
exports.xorStrings = xorStrings;
/**
 * Create an identity string the servers can decode.
 */
function encodeUserId(identity) {
    return `${base64EncodeString(identity.type)}.${base64EncodeString(identity.name)}.${base64EncodeString(identity.id)}`;
}
exports.encodeUserId = encodeUserId;
//# sourceMappingURL=index.js.map